import React from 'react';
import { useField } from 'react-final-form';

import StarsDropDown from '@swf/components/Inputs/StarsDropDown';
import Translation from '@swf/components/Translation/Translation';
import { Tooltip } from '@swf/poker';

import InfoIcon from '../assets/info.svg';
import {
  dayOptions,
  monthlyRepeatOptions,
  recurringDayOptions,
  whichRecurringDayOptions
} from '../utils/monthlyOptions';
import { MonthlyRepeat } from '../utils/utils';

import {
  TXTWCL_For_months_with_fewer_than_31__ELL,
  TXTWCL_Repeat,
  TXTWCL_of_the_month
} from './Monthly.messages.json';
import styles from './Monthly.scss';

const Monthly: React.FC = () => {
  const {
    input: { value: monthlyRepeat }
  } = useField('monthlyRepeat', { defaultValue: 0 });
  useField('dayOfMonth', { defaultValue: 1 });
  useField('recurringDay', { defaultValue: 'HG_RD_MONDAY' });
  useField('whichRecurringDay', { defaultValue: 'HG_WRD_FIRST' });

  return (
    <div className={styles.container}>
      <div className={styles.monthlyRepeat}>
        <StarsDropDown
          className={styles.dropdown}
          label={TXTWCL_Repeat}
          id="monthlyRepeat"
          options={monthlyRepeatOptions}
        />
      </div>
      {monthlyRepeat === MonthlyRepeat.OnDay && (
        <div className={styles.onDay}>
          <StarsDropDown
            hideLabel
            className={styles.dropdown}
            label="Day of Month"
            id="dayOfMonth"
            options={dayOptions}
          />
          <p>
            <Translation {...TXTWCL_of_the_month} />
          </p>
          <Tooltip
            arrowClassName={styles.tooltipArrow}
            tooltipClassName={styles.tooltip}
            content={<Translation {...TXTWCL_For_months_with_fewer_than_31__ELL} />}
          >
            <div className={styles.infoIcon}>
              <InfoIcon />
            </div>
          </Tooltip>
        </div>
      )}
      {monthlyRepeat === MonthlyRepeat.OnThe && (
        <div className={styles.onThe}>
          <div className={styles.whichRecurringDay}>
            <StarsDropDown
              hideLabel
              className={styles.dropdown}
              label="Which Recurring"
              id="whichRecurringDay"
              options={whichRecurringDayOptions}
            />
          </div>
          <div>
            <StarsDropDown
              hideLabel
              className={styles.dropdown}
              label="Recurring Day"
              id="recurringDay"
              options={recurringDayOptions}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Monthly;
